<section class="api-card api-card--full totals-card" [class.totals-card--loading]="loading() && !skeleton()" [attr.aria-busy]="loading() || skeleton()">
  <div class="api-card__header">
    <div class="api-card__header-stack">
      <h2 class="api-card__title totals-card__title">Totals</h2>
      @if (description()) {
        <span class="api-card__desc">{{ description() }}</span>
      }
    </div>
    @if (skeleton()) {
      <app-skeleton width="120px" height="24px" radius="99px"></app-skeleton>
    } @else {
      <span class="totals-chip" [class.totals-chip--filtered]="filtered()">
        <span class="totals-chip__dot" aria-hidden="true"></span>
        {{ chipText() }}
      </span>
    }
  </div>

  @if (skeleton()) {
    <div class="totals-card__figures" [style.--totals-cols]="columns()" aria-label="Loading totals">
      @for (label of skeletonLabels(); track label) {
        <div class="totals-skeleton">
          <span class="totals-skeleton__label">{{ label }}</span>
          <app-skeleton width="110px" height="28px" radius="6px"></app-skeleton>
          <app-skeleton width="140px" height="14px"></app-skeleton>
        </div>
      }
    </div>
  } @else {
    <dl class="totals-card__figures" [style.--totals-cols]="columns()">
      <ng-content select="[appTotalsFigure]" />
    </dl>

    <ng-content select="[totalsFooter]" />
  }
</section>
